import React from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import type { LightboxProps } from './types';
import { getImageUrl } from './utils';

export const Lightbox: React.FC<LightboxProps> = ({
  isOpen,
  currentIndex,
  items,
  onClose,
  onPrev,
  onNext,
}) => {
  if (!isOpen || !items[currentIndex]) return null;

  const currentItem = items[currentIndex];
  const imageUrl = getImageUrl(currentItem);

  return (
    <div
      className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 p-2 text-white hover:bg-white/20 rounded-full transition-colors"
        aria-label="Close lightbox"
      >
        <X size={24} />
      </button>
      {items.length > 1 && (
        <>
          <button
            onClick={e => {
              e.stopPropagation();
              onPrev();
            }}
            className="absolute left-4 p-2 text-white hover:bg-white/20 rounded-full transition-colors"
            aria-label="Previous image"
          >
            <ChevronLeft size={32} />
          </button>
          <button
            onClick={e => {
              e.stopPropagation();
              onNext();
            }}
            className="absolute right-4 p-2 text-white hover:bg-white/20 rounded-full transition-colors"
            aria-label="Next image"
          >
            <ChevronRight size={32} />
          </button>
        </>
      )}
      <div className="max-w-7xl max-h-full" onClick={e => e.stopPropagation()}>
        <img
          src={imageUrl}
          alt={currentItem.alt || `Gallery image ${currentIndex + 1}`}
          className="max-w-full max-h-[90vh] object-contain"
        />
        {currentItem.caption && (
          <p className="text-white text-center mt-4 text-lg">{currentItem.caption}</p>
        )}
      </div>
    </div>
  );
};
